import { media } from '@atlaskit/primitives/responsive';
import { token } from '@atlaskit/tokens';
import { FluidContainer } from '@atlassian/mpac-primitives';
import { styled } from '@compiled/react';

import { IconButton } from './Buttons/Button.styles';

export const Container = styled.header({
  position: 'sticky',
  top: 0,
  zIndex: 200,
});

export const NavbarBackground = styled.div({
  background: token('elevation.surface.overlay'),
  borderBottom: `1px solid ${token('color.border')}`,
  position: 'relative',
});

export const NavbarBackgroundWC = styled.div({
  background: token('elevation.surface.overlay'),
  position: 'relative',
});

export const NavbarContainer = styled(FluidContainer)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: 'auto',
  height: '64px',
  [media.above.sm]: {
    height: '72px',
  },
  alignItems: 'stretch',
});

export const NavbarContainerWC = styled(FluidContainer)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: 'auto',
  height: '4.25rem',
  alignItems: 'center',
  alignSelf: 'stretch',
  [media.above.md]: {
    padding: `0.625rem 0rem`,
  },
  [media.above.sm]: {
    height: '4.5rem',
  },
});

export const LogoAndMenuContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const LogoAndMenuContainerWC = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: token('space.400'),
});

export const ActionButtonsContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: token('space.200'),
});

export const ActionButtonsContainerWC = styled.div({
  display: 'flex',
  alignItems: 'center',
  height: token('space.500'),
  gap: token('space.100'),
});

export const MenuButtonsContainer = styled.div({
  marginLeft: token('space.200', '16px'),
  display: 'flex',
  gap: token('space.100'),
  height: '100%',
  alignItems: 'center',
  '&:focus-visible': {
    outline: 'none',
  },
});

export const MenuButtonsContainerWC = styled.div({
  display: 'flex',
  alignItems: 'center',
  paddingTop: token('space.050'),
});

export const VerticalRule = styled.span({
  height: '24px',
  width: '1px',
  marginLeft: `${token('space.100')}`,
  backgroundColor: token('color.border'),
});

export const VerticalRuleWC = styled.div({
  width: '1px',
  height: '32px',
  backgroundColor: token('color.border'),
});

export const ActionButton = styled(IconButton)({
  marginLeft: token('space.100'),
});
